import { Action } from '@ngrx/store';
import * as models from '../models';

export const LOAD = '[Shared.AircraftCategory] Load';
export const LOAD_SUCCESS = '[Shared.AircraftCategory] Load Success';
export const LOAD_FAIL = '[Shared.AircraftCategory] Load Fail';

export class LoadAction implements Action {
  readonly type = LOAD;
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: Array<models.AircraftCategory>) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction;
